var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "console-setting-wrap" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.tableClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _vm.showMember
            ? _c(
                "el-tab-pane",
                { attrs: { name: "tab-member" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("成员管理")
                  ]),
                  _c("member")
                ],
                1
              )
            : _vm._e(),
          _vm.showApproval
            ? _c(
                "el-tab-pane",
                { attrs: { name: "tab-approval" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("审批设置")
                  ]),
                  _c("flow")
                ],
                1
              )
            : _vm._e(),
          _vm.showSeal
            ? _c(
                "el-tab-pane",
                { attrs: { name: "tab-seal" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("印章授权")
                  ]),
                  _c("seal")
                ],
                1
              )
            : _vm._e(),
          _vm.showTemplate
            ? _c(
                "el-tab-pane",
                { attrs: { name: "tab-template" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("模板授权")
                  ]),
                  _c("template-manage")
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d40862f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d40862f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/console/setting.vue
// module id = MF0S
// module chunks = 7